/**
 * Notification sounds using Web Audio API — no audio file imports needed.
 */

let audioCtx = null;
let muted = false;

function getAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

function playTone(frequency, duration, volume = 0.15) {
  if (muted) return;
  try {
    const ctx = getAudioContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = 'sine';
    osc.frequency.value = frequency;
    gain.gain.value = volume;
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration);
  } catch (e) {
    // Audio context blocked by browser policy — ignore
  }
}

/** Short 440Hz beep for normal messages */
export function playMessageSound() {
  playTone(440, 0.1, 0.1);
}

/** Two-tone 440Hz -> 880Hz for urgent messages */
export function playUrgentSound() {
  if (muted) return;
  playTone(440, 0.15, 0.2);
  setTimeout(() => playTone(880, 0.15, 0.2), 160);
}

export function setMuted(val) {
  muted = val;
}

export function isMuted() {
  return muted;
}
